import styles from './index.module.scss';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { IMessageItem, MessageType } from '../../../model/api-modules/message';
import { messageReads, messageRed } from '../../../api';
import {
  getCustomUserSubject,
  getCustomSystemTitle,
  getCustomSystem,
} from './config';
import { MessageModal } from './message-modal';
import noUnread from '../../../assets/svg/msg-empty.svg';
import { getLocaleLanguage, getLocalTime, LanguageType } from '../../../lib';
import { messageInfo } from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly messageList: ReadonlyArray<IMessageItem>;
  readonly unreadMessageList: ReadonlyArray<IMessageItem>;
  readonly getUnreadMessageList: () => void;
  readonly lang?: LanguageType | null;
}

export const MessageCenter = (props: IProps) => {
  // 查看的 未读消息
  const [unreadMessage, setUnreadMessage] = useState<IMessageItem | null>(null);
  const [selectStatus, setSelectStatus] = useState<number>(0);
  const [isEmpty, setIsEmpty] = useState<boolean>(false);
  const currentLanguage = props.lang || getLocaleLanguage();

  // 查看
  const onLookMessage = (item: IMessageItem) => {
    setUnreadMessage(item);
    // ReadInfo 存在代表是已读消息 不再更新数据状态
    if (!item.ReadInfo) {
      messageRed(item.id).then(() => {
        props.getUnreadMessageList();
      });
    }
  };

  useEffect(() => {
    let isSetUnreadsEmpty = true;
    props.messageList.map((item) => {
      if (!item.ReadInfo) {
        isSetUnreadsEmpty = false;
      }
      return isSetUnreadsEmpty;
    });
    setIsEmpty(isSetUnreadsEmpty);
  }, [props.messageList]);

  const onOk = async () => {
    setUnreadMessage(null);
    return true;
  };

  const onCloseFail = () => {
    setUnreadMessage(null);
  };

  const onClick = (e: any) => {
    e.stopPropagation();
  };
  // 一键已读
  const onMarkRead = () => {
    if (props.unreadMessageList && props.unreadMessageList.length > 0) {
      const list: number[] = [];
      props.unreadMessageList.forEach((item) => {
        list.push(item.id);
      });
      messageReads(list).then((res) => {
        if (res === 0) {
          messageInfo(
            getFormatMessage(
              'notifications_as_read',
              {},
              currentLanguage || LanguageType.en_US
            )
          );
          props.getUnreadMessageList();
        }
      });
    }
  };

  const renderContent = () => {
    if (props.messageList.length < 1 || (selectStatus === 0 && isEmpty)) {
      return (
        <div
          className={classNames(
            styles.boxContentEmpty
            // 'webkit-box flex-center'
          )}
        >
          <img src={noUnread} />
          <div className={styles.msgEmpty}>
            {' '}
            —{' '}
            {getFormatMessage(
              'no_unread_notifications',
              {},
              currentLanguage || LanguageType.en_US
            )}{' '}
            —{' '}
          </div>
        </div>
      );
    }
    return props.messageList.map((item) => {
      if (selectStatus === 0 && item.ReadInfo) {
        return null;
      }
      return (
        <div
          key={item.id}
          className={styles.messageItem}
          onClick={() => {
            onLookMessage(item);
          }}
        >
          <div className="webkit-box flex-space-between">
            <div className={styles.messageMsgSubject}>
              {item.Type === MessageType.UserActive
                ? getFormatMessage(
                    'notice_type',
                    {},
                    currentLanguage || LanguageType.en_US
                  )
                : getCustomSystem(item.SubType)}
            </div>
            <div className={styles.messageTime}>
              {getLocalTime(item.CreateTime)}
            </div>
          </div>
          <div
            className={classNames(
              !item.ReadInfo ? styles.textSelected : styles.content
            )}
          >
            {item.Type === MessageType.UserActive
              ? getCustomUserSubject(item.SubType)
              : `${getCustomSystemTitle(item.SubType)}${item.Title}`}
          </div>
        </div>
      );
    });
  };

  return (
    <div onClick={onClick} className={styles.messageCenterBox} tabIndex={0}>
      <div>
        <div className="webkit-box flex-justify-space-between m-b">
          <div className={styles.boxHeadLeft}>
            {getFormatMessage(
              'message_center',
              {},
              currentLanguage || LanguageType.en_US
            )}
          </div>
          <div
            className={
              props.unreadMessageList.length > 0
                ? classNames(styles.boxHeadRight, 'webkit-box')
                : classNames(
                    styles.boxHeadRight,
                    styles.notAllowed,
                    'webkit-box'
                  )
            }
            onClick={onMarkRead}
          >
            {getFormatMessage(
              'mark_as_read',
              {},
              currentLanguage || LanguageType.en_US
            )}
          </div>
        </div>
        <div className={styles.messageCenterBottom}>
          <div
            className={
              selectStatus === 0
                ? classNames(styles.unreadsBtn, styles.btnActive)
                : styles.unreadsBtn
            }
            onClick={() => {
              setSelectStatus(0);
            }}
          >
            {getFormatMessage(
              'un_reads',
              {},
              currentLanguage || LanguageType.en_US
            )}
          </div>
          <div
            className={
              selectStatus === 1
                ? classNames(styles.allBtn, styles.btnActive)
                : styles.allBtn
            }
            onClick={() => {
              setSelectStatus(1);
            }}
          >
            {getFormatMessage('all', {}, currentLanguage || LanguageType.en_US)}
          </div>
        </div>
      </div>
      <div className={styles.messageBox}>{renderContent()}</div>
      {unreadMessage && (
        <MessageModal
          message={unreadMessage}
          onOk={onOk}
          onCloseFail={onCloseFail}
        />
      )}
    </div>
  );
};
